import {assertAndContinue} from 'Asserts';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import {makeReactContext} from 'lib/makeReactContext';
interface BlockViewContextOutput {
  actionOrigin: ActionOrigin;
  viewStateId: string;
}
export const DEFAULT_BLOCK_VIEW_OUTPUT: BlockViewContextOutput = {
  actionOrigin: ActionOrigin.INSIGHTS,
  viewStateId: 'BlockViewState-UNKNOWN',
};

/**
 * Provide an BlockViewStateId for consumers to use to manage this block's BlockViewState.
 *
 * This context should be provided by top-level block components. Some block children are better suited to
 * manage parts of the BlockViewState, so we give that responsibility to them. This context helps give them
 * an ID to use when managing that state.
 */
export const BlockViewContext = makeReactContext<BlockViewContextOutput>(() => {
  assertAndContinue(
    false,
    `Could not find block view context while rendering analytics component, defaulting to ${DEFAULT_BLOCK_VIEW_OUTPUT}`
  );
  return DEFAULT_BLOCK_VIEW_OUTPUT;
}, 'BlockViewContext');
